;((w, $) => {
  'use strict';

  // console.log('dev');
  const stars_html = `<div class="yotpo-bottomline pull-left  star-clickable __star-gray" tabindex="0">  <span class="yotpo-stars"> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="sr-only">5.0 star rating</span> </span>     <div class="yotpo-clr"></div> </div>`
    
  const addEmptyStars = () => {
    const $wrapStars = $('.product-tile .yotpo.bottomLine');
    $wrapStars.each(function() {
      const $self = $(this);
      if($self.find('.yotpo-bottomline').length == 0) {
        // var api = new Yotpo.API(yotpo);
        // api.refreshWidgets();
        
        $self.append(stars_html)
      }
    })
  }

  $(() => {
    setInterval(() => {
      addEmptyStars();
    }, 1000)
  })
  
})(window, jQuery)